/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewCompanyMeetingRequest
 */
export interface PreviewCompanyMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewCompanyMeetingRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof PreviewCompanyMeetingRequest
   */
  jamieMeetingId: string;
}

/**
 * Check if a given object implements the PreviewCompanyMeetingRequest interface.
 */
export function instanceOfPreviewCompanyMeetingRequest(
  value: object,
): value is PreviewCompanyMeetingRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function PreviewCompanyMeetingRequestFromJSON(
  json: any,
): PreviewCompanyMeetingRequest {
  return PreviewCompanyMeetingRequestFromJSONTyped(json, false);
}

export function PreviewCompanyMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewCompanyMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    jamieMeetingId: json["jamieMeetingId"],
  };
}

export function PreviewCompanyMeetingRequestToJSON(
  json: any,
): PreviewCompanyMeetingRequest {
  return PreviewCompanyMeetingRequestToJSONTyped(json, false);
}

export function PreviewCompanyMeetingRequestToJSONTyped(
  value?: PreviewCompanyMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    jamieMeetingId: value["jamieMeetingId"],
  };
}
